export const BuildInfo = {timestamp:1791406425000}
